import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import TabviewControllersContainer from "../../../components/layouts/containers/TabviewControllersContainer.container"
import ClientReportPeriodSelector from "../components/ClientReportPeriodSelector.compound"
import useReportFiltersContext from "../../../hooks/contextConsumers/useReportFiltersContext.hook"
import { CLIENT_REPORT_TABS_WITH_ONLY_SPRINTS } from "../../../consts/modules/clientReport.consts"
import useScreenDimensionsContext from "../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { AppRoutes } from "../../../consts/appRoutes.consts"

const ClientReportControls = ({
  period,
  setPeriod,
  dateRange,
  setDateRange,
  refresh,
  setRefresh,
  loading,
  currentTab,
  selectedPeriod,
  setSelectedPeriod,
  clientSprints,
  setClientSprints,
  setClientHasValidSprint,
  sprintBlocks = [],
  sprintCycles = [],
}) => {
  const [pickerContainer, setPickerContainer] = useState(null)
  const { clientReportSelectedClient } = useReportFiltersContext()
  const { screenWidth } = useScreenDimensionsContext()
  const isMobile = screenWidth <= 480
  const allowBlockPeriod =
    currentTab === AppRoutes.reporteCliente.descargaReporte &&
    sprintBlocks.length > 0
  const allowCyclePeriod =
    currentTab === AppRoutes.reporteCliente.descargaReporte &&
    sprintCycles.length > 0

  useEffect(() => {
    const container = document.querySelector("#reporte-cliente .p-tabview-nav")
    if (container) {
      setPickerContainer(container)
      setRefresh(true)
    }
  }, [setRefresh])

  const content = (
    <TabviewControllersContainer className="client-report-controls">
      <ClientReportPeriodSelector
        refresh={refresh}
        dateRange={dateRange}
        setDateRange={setDateRange}
        period={period}
        setPeriod={setPeriod}
        disabledChevrons={loading}
        clientId={clientReportSelectedClient}
        onlyAllowSprints={CLIENT_REPORT_TABS_WITH_ONLY_SPRINTS.includes(
          currentTab
        )}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        clientSprints={clientSprints}
        setClientSprints={setClientSprints}
        setClientHasValidSprint={setClientHasValidSprint}
        allowBlockPeriod={allowBlockPeriod}
        allowCyclePeriod={allowCyclePeriod}
        sprintBlocks={sprintBlocks}
        sprintCycles={sprintCycles}
      />
    </TabviewControllersContainer>
  )

  if (isMobile) return content
  if (!pickerContainer || !clientReportSelectedClient) return null
  return createPortal(content, pickerContainer)
}

export default ClientReportControls
